import { Injectable, Injector, inject } from '@angular/core';
import { DefaultTranspiler, type TranspileParams, TranslocoService } from '@jsverse/transloco';

import { formatNumber } from '../shared/format/locale-format';

/**
 * Every number handed to a translation — « {{ count }} jours », « Version {{ version }} » — is
 * written in the digits of the language being read, so no caller has to remember to. Strings
 * pass through untouched.
 */
@Injectable()
export class LocalisedNumbersTranspiler extends DefaultTranspiler {
  // Read at each call: TranslocoService itself depends on the transpiler, so it cannot be
  // injected up front.
  private readonly injector = inject(Injector);

  override transpile(params: TranspileParams): unknown {
    const values = params.params;
    if (values === undefined || values === null) return super.transpile(params);
    const language = this.injector.get(TranslocoService).getActiveLang();
    const localised = Object.fromEntries(
      Object.entries(values).map(([name, value]) => [
        name,
        typeof value === 'number' ? formatNumber(value, language) : value,
      ]),
    );
    return super.transpile({ ...params, params: localised });
  }
}
